


















































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import PageContainer from '@/components/PageContainer.vue';
import CLButton from '@/components/CLButton.vue';

const BottomPlaceholder = () => import(/* webpackChunkName: "homePlaceholders" */ '@/components/placeholders/BottomPlaceholder.vue');

@Component({
  name: 'Home',
  components: {
    PageContainer,
    CLButton,
    BottomPlaceholder,
  },
  computed: mapGetters(['pageLoaded']),
})
export default class Home extends Vue {}
